export default __webpack_public_path__ + "static/media/onix.6dbfcd08.png";